<template>
  <div
    class="mini-card"
    :class="{ 'mini-card--clickable': clickable }"
    role="button"
    :tabindex="clickable ? 0 : -1"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick">
    <!-- Main content frame -->
    <div class="mini-card__content">
      <!-- Icon slot -->
      <div class="mini-card__icon">
        <slot name="icon"></slot>
      </div>

      <!-- CTA text -->
      <span class="mini-card__text">
        {{ text }}
      </span>

      <!-- Text icon slot (conditional) -->
      <div
        v-if="$slots.textIcon"
        class="mini-card__text-icon">
        <slot name="textIcon"></slot>
      </div>

      <!-- Arrow slot -->
      <div class="mini-card__arrow">
        <slot name="arrow"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
  // Props
  const props = defineProps({
    text: {
      type: String,
      default: 'Fissa un appuntamento'
      // validator: value => typeof value === 'string' && value.trim().length > 0
    },
    clickable: {
      type: Boolean,
      default: true
    }
  })

  // Emits
  const emit = defineEmits([ 'click' ])

  // Methods
  const handleClick = event => {
    if (props.clickable) {
      emit('click', event)
    }
  }
</script>

<style lang="scss" scoped>
.mini-card {
  // Layout based on Figma specs
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 30px 20px 20px;
  width: 202px;
  height: 100%; // Ensure full height usage
  min-height: 200px; // Set a minimum height

  // Appearance - red border, no shadows, no animations
  background: var(--color-white);
  border-radius: 10px;
  border: 1px solid var(--color-red);

  &--clickable {
    cursor: pointer;
  }

  // Focus states
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  &:focus-visible {
    outline: 2px solid var(--color-red);
    outline-offset: 2px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    gap: 24px;
    flex-grow: 1; // Allow content to grow and push arrow to bottom
  }

  &__icon {
    width: 40px;

    // height: 35px;
    color: var(--color-red);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__text {
    // Typography based on Figma specs
    font-family: var(--font-family-poppins);
    font-weight: var(--font-weight-book, 400);
    font-size: 16px;
    line-height: 1.4;
    letter-spacing: 0.16px; // 1% of 16px
    text-transform: uppercase;
    text-align: center;
    color: var(--color-red);

    // Layout
    width: 100%;
    overflow-wrap: break-word;
  }

  &__text-icon {
    width: 24px;
    height: 24px;
    color: var(--color-red);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__arrow {
    width: 24px;
    height: 24px;
    color: var(--color-red);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  // Responsive design
  @include mq($until: tablet) {
    flex-direction: row;
    width: 100%;
    padding: var(--space-s);
    gap: 12px;
    min-height: unset; // Set a minimum height
    border: none;
    justify-content: center;

    &__content {
      flex-direction: row;
      gap: var(--space-ss-desktop);
      max-width: 270px;
    }

    &__icon {
      // width: 20px;
      // height: 20px;
    }

    &__text {
      font-size: 14px;
      letter-spacing: 0.14px;
      flex-grow: 1; // Ensure text takes all available space
      text-align: left;
      padding-top: 4px;
    }

    &__text-icon {
      width: 20px;
      height: 20px;
    }

    &__arrow {
      margin-top: -4px;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
